import ModelFactory from 'business/models/ModelFactory';
import {
  SynchTripClient,
  SynchTripDTO,
  SynchTripResultExportDTO,
  SynchTripImportDTO,
  SynchTripResultImportDTO,
  SynchTripsExpReportDTO,
} from 'business/models/Models';
import BaseService from './BaseService';

export default class SynchTripService extends BaseService {
  async getSynchTripById(id: number) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.getSynchTripById(id);
  }

  async saveSynchTrip(synchTripDto: SynchTripDTO) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.save(synchTripDto);
  }

  async getOpenSynchTrips() {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.getOpenSynchTrips();
  }

  async deleteSynchTripFromExperiment(tripId: number) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.deleteSynchTripFromExp(tripId);
  }

  async isSynchTripCrystalsResultsExist(tripId: number) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.checkTripCrystalsResultsExists(tripId);
  }

  async createSynchTrip(treeNodeId: number) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.createSynchTrip(treeNodeId);
  }

  async getSynchTripsNodeInfo() {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.getSynchTripsNodeInfo();
  }

  async verifySynchTripImportData(SynchTripImportDTOs: SynchTripImportDTO[]) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);

    return await synchTripClient.verifySynchTripImportData(SynchTripImportDTOs);
  }

  async getSynchTripsRootTreeNodeId() {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient);
    return await synchTripClient.getSynchTripsRootTreeNodeId();
  }

  async getSynchTripReport(tripIds: number[]) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.getSynchTripReport(tripIds);
  }

  async getSynchTripExportCSV(tripId: number) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.getSynchTripExportCSV(tripId);
  }

  async verifySynchTripResultImportData(tripResults: SynchTripResultImportDTO[]) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);

    return await synchTripClient.verifySynchTripResultImport(tripResults);
  }

  async saveSynchTripResultImportData(tripResults: SynchTripResultImportDTO[]) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);

    return await synchTripClient.saveSynchTripResultImportData(tripResults);
  }

  async getSynchTripResultsExportCSV(synchTripResultsDto: SynchTripResultExportDTO[]) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.exportSynchTripResults(synchTripResultsDto);
  }

  async getSynchTripCrystalCount(id: number) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.getSynchTripCrystalCount(id);
  }

  async getLatestSynchrotronTrips(): Promise<SynchTripDTO[]> {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.getLatestSynchrotronTrips();
  }

  async getSynchTripsByExpId(id: number) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.getSynchTripsByExpId(id);
  }

  async getSynchTripsExpReport(reportDto: SynchTripsExpReportDTO) {
    const synchTripClient: SynchTripClient = ModelFactory(SynchTripClient, false, true);
    return await synchTripClient.getSynchTripsExpReport(reportDto);
  }
}
